import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { useCurrentEditor } from "@tiptap/react";
import { type FC, type RefObject, useCallback, useState } from "react";
import { useElementFromRef } from "../../../hooks";
import { Popover, PopoverContent, PopoverTrigger } from "../../popover";
import { EditorButton, type EditorButtonProps } from "./editor-button";

export interface EditorButtonEmojiProps extends EditorButtonProps {
  containerRef?: RefObject<HTMLDivElement | null>;
}

export const EditorButtonEmoji: FC<EditorButtonEmojiProps> = ({ containerRef, ...props }) => {
  const container = useElementFromRef(containerRef);
  const [isOpen, setIsOpen] = useState(false);
  const { editor } = useCurrentEditor();

  const handleEmojiSelect = useCallback(
    (emoji: { native: string }) => {
      if (!editor) {
        return;
      }
      editor.chain().focus().insertContent(emoji.native).run();
      setIsOpen(false);
    },
    [editor]
  );

  if (!editor) {
    return null;
  }

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <EditorButton {...props} icon="mood" tooltip="Insert emoji" />
      </PopoverTrigger>
      <PopoverContent container={container} className="w-auto p-0 overflow-hidden" align="start">
        <Picker data={data} onEmojiSelect={handleEmojiSelect} previewPosition="none" skinTonePosition="none" />
      </PopoverContent>
    </Popover>
  );
};
